// Single source of truth for plan feature lists, sublines, and ordering.
// Used by PricingSection and UpgradeModal to prevent copy drift.

import type { PlanTier } from "@/lib/planGating";

export interface PlanDisplayConfig {
  tier: PlanTier;
  name: string;
  price: string;
  period?: string;
  priceId?: string;
  subline: string;
  features: string[];
  highlighted: boolean;
  badge?: string;
}

export const PLAN_CONFIGS: PlanDisplayConfig[] = [
  {
    tier: "free",
    name: "Free",
    price: "$0",
    subline: "Start here",
    features: [
      "2 decisions per day",
      "Save and revisit decisions",
      "5 Pro-level trial searches",
    ],
    highlighted: false,
  },
  {
    tier: "pro",
    name: "Pro",
    price: "$29",
    period: "/mo",
    priceId: "pro_monthly_v3",
    badge: "Most popular",
    subline: "Know exactly why it won",
    features: [
      "Decide anytime — 400/month",
      "Deeper source analysis per decision",
      "Full audit trail: why it won, what you lose",
      "Price tracking on saved items",
      "Preference memory across sessions",
    ],
    highlighted: true,
  },
  {
    tier: "elite",
    name: "Elite",
    price: "$59",
    period: "/mo",
    priceId: "elite_monthly_v3",
    subline: "For power buyers and teams",
    features: [
      "Maximum search depth and source coverage",
      "Priority processing",
      "Broader market and category reach",
      "Everything in Pro",
    ],
    highlighted: false,
  },
];
